export enum PitchesRoutes {
  CreateOne = 'create-one',
  DeleteMany = 'delete-many',
  GetList = 'get-list',
  GetOne = 'get-one',
  GetReferenceList = 'get-reference-list',
  Search = 'search',
  UpdateMany = 'update-many',
  UpdateMsDict = 'update-ms-dict',
}
